import {clsx} from 'clsx';
import styles from './categories.module.css';

type Props = {
  readonly openNaviMenu: () => void;
};

export function Categories({openNaviMenu}: Props) {
  return (
    <ul className={styles.list}>
      <li className={styles.item}>
        <a href='/'>Top</a>
      </li>
      <li className={styles.item}>
        <a href='/technology/'>テクノロジー</a>
      </li>
      <li className={styles.item}>
        <a href='/mobile/'>モバイル</a>
      </li>
      <li className={styles.item}>
        <a href='/app/'>アプリ</a>
      </li>
      <li className={styles.item}>
        <a href='/entertainment/'>エンタメ</a>
      </li>
      <li className={styles.item}>
        <a href='/beauty/'>ビューティー</a>
      </li>
      <li className={styles.item}>
        <a href='/fashion/'>ファッション</a>
      </li>
      <li className={clsx(styles.item, styles.hiddenWhenSmallerThan800)}>
        <a href='/lifestyle/'>ライフスタイル</a>
      </li>
      <li className={clsx(styles.item, styles.hiddenWhenSmallerThan860)}>
        <a href='/business/'>ビジネス</a>
      </li>
      <li className={clsx(styles.item, styles.hiddenWhenSmallerThan920)}>
        <a href='/gourmet/'>グルメ</a>
      </li>
      <li className={clsx(styles.item, styles.hiddenWhenSmallerThan980)}>
        <a href='/sports/'>スポーツ</a>
      </li>

      <li className={styles.more}>
        <button
          type='button'
          aria-label='他のカテゴリを表示する'
          onClick={openNaviMenu}
        >
          &hellip;
        </button>
      </li>
    </ul>
  );
}
